import { AbstractListModel } from '@libs/factory/abstract-list/abstract-list.model';
import { marker } from '@colsen1991/ngx-translate-extract-marker';


/**
 *  "1": "Discount coupons",
 *  "2": "Ticket vouchers",
 *  "3": "Top-up coupons",
 *  "4": "Promo tickets"
 */
export enum DiscountProgramType {
    DiscountCoupons = 1,
    TicketVouchers = 2,
    TopUpCoupons = 3,
    PromoTickets = 4,
}

/**
 *  "1": "Amount",
 *  "2": "Percent",
 */
export enum DiscountProgramCpnType {
    Amount = 1,
    Percent = 2,
}

export const discountProgramTypes: AbstractListModel[] = [
    {
        id: DiscountProgramType.DiscountCoupons,
        title: marker('disc.data.programTypes.1'),
    },
    {
        id: DiscountProgramType.TicketVouchers,
        title: marker('disc.data.programTypes.2'),
    },
    {
        id: DiscountProgramType.TopUpCoupons,
        title: marker('disc.data.programTypes.3'),
    },
    {
        id: DiscountProgramType.PromoTickets,
        title: marker('disc.data.programTypes.4'),
    },
];
